<div class="container-group">
  <div *ngIf="data">
    <div class="grup header headers">
      <div class="value key">{{'PACKAGE.KEY.CAPTION' | translate}}</div>
      <div class="value xDimension">{{'PACKAGE.XDIMENSION.CAPTION' | translate}}</div>
      <div class="value yDimension">{{'PACKAGE.YDIMENSION.CAPTION' | translate}}</div>
      <div class="value zDimension">{{'PACKAGE.ZDIMENSION.CAPTION' | translate}}</div>
      <div class="value kg">{{'PACKAGE.KG.CAPTION' | translate}}</div>
      <div class="value button-sub-line">
        <confirmation-dialog [expanded]="askingCreateLabel" helptitleresource="PACKAGELABELCOMPONENT.CREATELABELS.CAPTION"
          helpresource="{{ getResourceCreateLabelsConfirm() }}" (onConfirm)="createLabel()"
          (onCancel)="askingCreateLabel = false"></confirmation-dialog>
        <i aria-hidden="true" matTooltip="{{ 'PACKAGELABELCOMPONENT.CREATELABELS.CAPTION' | translate }}"
          *ngIf="anyWithoutLabel" class=" cercle fa fa-file-text-o" (click)="askingCreateLabel = true"></i>
        <i aria-hidden="true" matTooltip="{{ getResourceDownLoadLabels() | translate }}"
           *ngIf="labelCandidate" class="cercle fa fa-cloud-download" (click)="downloadLabelsByDate()"></i>
      </div>
    </div>

    <shared-package-line-component *ngFor="let item of data" [provider]="provider" [routeId]="routeId" [shipmentId]="shipmentId"
      [package]="item" [readonly]="readonly" [routeId]="routeId">
    </shared-package-line-component>
    <shared-package-line-component *ngIf="!readonly" [readonly]="readonly" [provider]="provider" [routeId]="routeId"
      [ngClass]="{'shipment-package': shipmentId}" [shipmentId]="shipmentId" (packageCreated)="data.push($event)">
    </shared-package-line-component>
  </div>
</div>